import { render, staticRenderFns } from "./KardexInterno.vue?vue&type=template&id=8a6d4ffa&scoped=true"
import script from "./KardexInterno.vue?vue&type=script&lang=js"
export * from "./KardexInterno.vue?vue&type=script&lang=js"
import style0 from "./KardexInterno.vue?vue&type=style&index=0&id=8a6d4ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6d4ffa",
  null
  
)

export default component.exports